import PropTypes from 'prop-types'

export const SERVER_DATA = {
  pageProps: PropTypes.object.isRequired,
  reqContextData: PropTypes.object.isRequired,
}

export const HELP_CHANNEL_DATA = {
  iconName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  target: PropTypes.string,
  url: PropTypes.string.isRequired,
}

export const MORE_WAYS_OF_HELP_DATA = {
  helpChannels: PropTypes.arrayOf(PropTypes.shape(HELP_CHANNEL_DATA)),
}

export const ARTICLE_CONTENT_DATA = {
  articleContent: PropTypes.shape({
    articleContent: PropTypes.string.isRequired,
    articleTitle: PropTypes.string.isRequired,
    ecmComponentIds: PropTypes.string,
    ecmDocId: PropTypes.string,
  }),
  articleId: PropTypes.string.isRequired,
  exp: PropTypes.string.isRequired,
}

export const HERO_MODULE_DATA = {
  name: PropTypes.string,
}

export const ARTICLE_LINK_DATA = {
  articleId: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  usage: PropTypes.number,
  rank: PropTypes.number,
  views: PropTypes.number,
  channel: PropTypes.string.isRequired,
  target: PropTypes.string,
  link: PropTypes.string,
}
export const ARTICLE_LINKS_DATA = {
  articlesData: PropTypes.arrayOf(PropTypes.shape(ARTICLE_LINK_DATA)),
  componentName: PropTypes.string.isRequired,
  articleId: PropTypes.string.isRequired,
}

export const TOPIC_TREE_DATA = {
  topicId: PropTypes.string.isRequired,
  topicName: PropTypes.string.isRequired,
}

export const TOPIC_TREE_COMPLETE_DATA = {
  breadCrumbPath: PropTypes.string,
  topicTreeData: PropTypes.arrayOf(PropTypes.shape(TOPIC_TREE_DATA)),
}

export const RECOMMENDED_ARTICLE_DATA = {
  articleId: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  channel: PropTypes.string,
  excerpt: PropTypes.string,
  rank: PropTypes.number,
  topicId: PropTypes.string,
  topicName: PropTypes.string,
  usage: PropTypes.number,
}

export const RECOMMENDED_SOLUTIONS_DATA = {
  recommendedSolutionsData: PropTypes.arrayOf(
    PropTypes.shape(RECOMMENDED_ARTICLE_DATA),
  ),
}

export const BREADCRUMBS_DATA = {
  breadCrumbPath: PropTypes.string,
  breadCrumbTitle: PropTypes.string,
}

export const ARTICLE_FEEDBACK_DATA = {
  articleId: PropTypes.string,
  helpComponentIds: PropTypes.string,
}

export const TAB_INFO = {
  id: PropTypes.string.isRequired,
  tabProps: PropTypes.object.isRequired,
}
export const TAB_SWITCHER_DATA = {
  name: PropTypes.string.isRequired,
  tabsInfo: PropTypes.arrayOf(PropTypes.shape(TAB_INFO)).isRequired,
  renderTabContent: PropTypes.func.isRequired,
  articleId: PropTypes.string.isRequired,
}

export const ARTICLE_CONTENT_TABS_DATA = {
  articleContent: PropTypes.shape({
    articleTitle: PropTypes.string.isRequired,
    personalContent: PropTypes.string,
    businessContent: PropTypes.string,
    ecmComponentIds: PropTypes.string,
    ecmDocId: PropTypes.string,
  }),
  articleId: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
}

export const ALERTS_DATA = {
  pageName: PropTypes.string.isRequired,
}

export const COOKIE_BANNER_DATA = {
  js: PropTypes.string,
  css: PropTypes.string,
  html: PropTypes.string,
}

const REQ_CONTEXT_DATA = {
  isLoggedIn: PropTypes.bool.isRequired,
  userExperience: PropTypes.string.isRequired,
}

const CONSUMER_NAV_DATA = {
  footerHtml: PropTypes.string,
}

const MERCHANT_NAV_DATA = {
  footerEl: PropTypes.string,
}

export const NAVIGATION_DATA = {
  consumer: PropTypes.shape(CONSUMER_NAV_DATA),
  merchant: PropTypes.shape(MERCHANT_NAV_DATA),
}

export const LAYOUT_FOOTER_DATA = {
  navigation: PropTypes.string,
  reqContextData: PropTypes.shape(REQ_CONTEXT_DATA),
}

export const FPTI_SETUP_DATA = {
  nonce: PropTypes.string,
  context: PropTypes.object,
  tracking: PropTypes.shape({
    addClientSideFptiData: PropTypes.func,
    doAnalytics: PropTypes.func,
  }),
  serverData: PropTypes.shape(SERVER_DATA),
}

export const LAYOUT_SERVER_DATA = {
  serverData: PropTypes.shape(SERVER_DATA),
}

export const ARTICLE_FEEDBACK_REASON_DATA = {
  onSubmit: PropTypes.func.isRequired,
}

export const HEADER_FOOTER_DATA = {
  isLoggedIn: PropTypes.bool.isRequired,
  serverData: PropTypes.shape(SERVER_DATA),
  reqContextData: PropTypes.shape(REQ_CONTEXT_DATA),
}
